import useGetUserLocationData from '@/api/account/useGetUserLocationData';
export default function useUserLocation() {
    const { data } = useGetUserLocationData();
    return {
        location: data === null || data === void 0 ? void 0 : data.location,
        country: data === null || data === void 0 ? void 0 : data.countryCode,
        userCurrencyByIp: data === null || data === void 0 ? void 0 : data.currencyCode,
    };
}
